// Single source of truth for menu label → internal program slug.
// Keep label keys in EXACT sync with the labels used in
// `PROGRAMS_BY_DELIVERY` inside `homeData.js` (en-dash, ampersand, punctuation).
// Any program listed here renders via React Router <Link> to its internal
// ProgramTemplate page. Programs NOT in this map fall back to the staging21
// search URL (external link, new tab) via the helpers in Header.jsx and
// ProgramFinder.jsx.

export const INTERNAL_PROGRAM_SLUGS = {
  "Personal Support Worker – Hybrid (27 Weeks)": "personal-support-worker",
  "Business Administration": "business-administration",
  "Medical Office Administrator": "medical-office-administrator",
  // 2026-02 (item 7): two labels routing to the split MOA surfaces.
  // Duration / accreditation removed per user request (2026-02 round 2)
  // — keep the menu chips short and let the page hero do the heavy lifting.
  "Medical Office Administrator (In-Campus)": "medical-office-administrator",
  "Medical Office Administrator (Online)": "medical-office-administrator-online",
  "Medical Laboratory Assistant Technician": "medical-laboratory-assistant",
  "Accounting & Payroll Administration Diploma": "accounting-and-payroll-administration",
  "Cardiology Technologist": "cardiology-technologist",
  "Intra Oral Level I & II Dental Assistant": "intra-oral-dental-assistant",
  "Pharmacy Technician": "pharmacy-technician",
  "Paralegal": "paralegal",
  // Batch 3 (2026-02-07)
  "Supply Chain and Logistics": "supply-chain-logistics",
  "Health Information Management": "health-information-management",
  "Information Technology (IT) Technician": "information-technology-technician",
  "Computer System Technician - Networking": "computer-system-technician-networking",
  "Computer System Technician – Networking": "computer-system-technician-networking",
  "Early Childhood Education": "early-childhood-education",
  "Medical Esthetician": "medical-esthetician",
  "Pharmacy Assistant": "pharmacy-assistant",
  // Batch 4 (2026-02-07) — final 10, closes all internal program routing
  "Diagnostic Medical Sonographer": "diagnostic-medical-sonographer",
  "Orthopaedic Technician": "orthopaedic-technician",
  // Orthopaedic Technician reinstated 2026-02-15 per business request — full page, forms, and menu links restored.
  // Physiotherapist & OTA retired 2026-08-25 — redirects to /programs/medical-laboratory-assistant.
  "Dental Radiography — H.A.R.P. Approved": "dental-radiography",
  "Law Enforcement / Police Foundations": "law-enforcement-police-foundations",
  "Occupational Health & Safety": "occupational-health-and-safety",
  "Early Childcare Assistant": "early-childcare-assistant",
  // Child & Youth Care With Addictions Support Worker retired 2026-08-25 — redirects to /programs/personal-support-worker.
  // "Medical Laboratory Technician" entry removed 2026-02 (item 6) — it
  // was a near-duplicate of MLAT. The standalone slug now redirects
  // to /programs/medical-laboratory-assistant via ProgramRoute.jsx so
  // existing inbound links continue to resolve.
  "Medical Laboratory Technology Hybrid": "medical-laboratory-technology",
};
